module.exports = (__webpack_require__(0))(231);


//////////////////
// WEBPACK FOOTER
// delegated ./src/index.js from dll-reference girder_lib
// module id = 4
// module chunks = 0